/* Rachel 2 Nov 2026 (Matt: colour buttons switch the photo; hover shows a second photo; no cut-outs).
   Reads assets/rw-photos.json (generated by work/ritter/photo_map/build_photo_map.py).
   - Product cards: hovering or tapping a colour dot shows that colour (model first, flat/back on hover).
   - Quick buy: the photo follows the chosen colour (window.rwPhotoFor).
   The product page gallery is server-rendered in snippets/product__images.liquid from the same map. */
(function(){
  var s=document.currentScript, url=s&&s.getAttribute('data-map'), MAP=null;
  /* the older per-swatch handler (rw-men-grid, data-full) must not fight this one */
  [].forEach.call(document.querySelectorAll('.rw-wl__sw i[data-full]'),function(i){ i.removeAttribute('data-full'); });
  function sz(u,w){ return u+(u.indexOf('?')>-1?'&':'?')+'width='+w; }
  function pick(e,c){
    var d=e&&e.c[c]; if(!d) return null;
    var a=(e.p&&e.p[c])||(d.model||d.flat||d.back||d.detail||d.life)[0]; /* card_pin (Matt 3 Nov: Rittervest opens on lifestyle) */
    var b=[].concat(d.flat||[],d.back||[],d.life||[],d.detail||[]).filter(function(x){ return x!==a; })[0];
    if(e.p&&e.p[c]){ b=(e.q&&e.q[c])||b; return {a:a,b:b,m:true}; }
    return {a:a,b:b,m:!!d.model};
  }
  function handleOf(card){
    var h=card.getAttribute('data-h'); if(h) return h;
    var a=card.querySelector('a.rw-wl__frame'), m=a&&(a.getAttribute('href')||'').match(/\/products\/([^\/?#]+)/);
    return m&&m[1];
  }
  function setCard(card,h,c){
    var r=pick(MAP[h],c); if(!r) return;
    var f=card.querySelector('.rw-wl__frame'); if(!f) return;
    var ims=f.querySelectorAll('img'), i1=ims[0], i2=ims[1];
    if(!i1){ i1=document.createElement('img'); i1.alt=''; f.insertBefore(i1,f.firstChild); }
    i1.removeAttribute('srcset'); i1.src=sz(r.a,800); i1.classList.toggle('rw-mdl',r.m); i1.classList.toggle('rw-z',r.m&&/_studio|_front\./.test(r.a)&&!/clara_|pisaq_/.test(r.a));
    if(r.b){ if(!i2){ i2=document.createElement('img'); i2.alt=''; i2.loading='lazy'; i1.parentNode.insertBefore(i2,i1.nextSibling); } i2.removeAttribute('srcset'); i2.src=sz(r.b,800); }
    else if(i2){ i2.parentNode.removeChild(i2); }
    [].forEach.call(card.querySelectorAll('.rw-wl__sw i'),function(i){ i.classList.toggle('is-on',i.getAttribute('title')===c); });
    card.setAttribute('data-c',c);
  }
  function initCards(){
    [].forEach.call(document.querySelectorAll('.rw-wl__card'),function(card){
      if(card.__rwp) return; var h=handleOf(card); if(!h||!MAP[h]) return; card.__rwp=1;
      if(card.getAttribute('data-h')) setCard(card,h,MAP[h].d); /* JS-built cards (women's data) start on the clean default */
      if(MAP[h].x){ var me=card.querySelector('.rw-wl__meta'), tot=card.querySelectorAll('.rw-wl__sw i').length, vis=tot-[].filter.call(card.querySelectorAll('.rw-wl__sw i'),function(i){ return MAP[h].x.indexOf(i.getAttribute('title'))>-1; }).length;
        if(me) me.innerHTML=me.innerHTML.replace(/\s*\u00b7?\s*\d+ colors/, vis>1?'\u00b7 '+vis+' colors':''); }
      [].forEach.call(card.querySelectorAll('.rw-wl__sw i'),function(i){
        var c=i.getAttribute('title');
        if(MAP[h].x && MAP[h].x.indexOf(c)>-1){ i.style.display='none'; return; }
        if(!MAP[h].c[c]){ i.classList.add('rw-nophoto'); i.setAttribute('title',c+' (photo coming soon)'); return; }
        i.addEventListener('mouseenter',function(){ setCard(card,h,c); });
        i.addEventListener('click',function(e){ e.preventDefault(); e.stopPropagation(); setCard(card,h,c); });
      });
    });
  }
  window.rwPhotoFor=function(h,v){
    if(!MAP||!MAP[h]||!v) return null;
    var opts=v.options||[v.option1,v.option2,v.option3];
    for(var k=0;k<opts.length;k++){ var r=pick(MAP[h],opts[k]); if(r) return sz(r.a,900); }
    /* a colour with no clean photo yet: show the default colour, never a cut-out (the caller adds a note) */
    var d=pick(MAP[h],MAP[h].d); return d ? sz(d.a,900)+'#rw-nophoto' : null;
  };
  window.rwPhotoMap=function(){ return MAP; };
  if(!url) return;
  /* colours with no approved photo yet (Joe 2 Nov): hidden on the product page and in quick buy too */
  function hideColours(){
    var pm=location.pathname.match(/\/products\/([^\/?#]+)/), ph=pm&&pm[1];
    if(ph && MAP[ph] && MAP[ph].x){
      var radios=[].slice.call(document.querySelectorAll('input[type=radio]')).filter(function(r){ return /colou?r/i.test(r.name||''); });
      radios.forEach(function(r){ if(MAP[ph].x.indexOf(r.value)>-1){ var w=r.closest('label')||r.parentNode; if(w) w.style.display='none'; r.disabled=true; } });
      var chk=radios.filter(function(r){ return r.checked; })[0];
      if(chk && MAP[ph].x.indexOf(chk.value)>-1 && (window.__rwSwitched||0)<2){ window.__rwSwitched=(window.__rwSwitched||0)+1; var ok=radios.filter(function(r){ return MAP[ph].x.indexOf(r.value)<0; })[0]; if(ok) setTimeout(function(){ ok.click(); },0); }
    }
    var qb=document.querySelector('.rw-qb.is-open, .rw-qb:not([hidden])'); if(qb){
      
      [].forEach.call(qb.querySelectorAll('.rw-qb__colour .rw-qb__sw, .rw-qb__colour button'),function(b){
        var c=(b.getAttribute('title')||b.textContent||'').trim();
        var qh2=window.__rwQbHandle, hit=qh2 && MAP[qh2] && MAP[qh2].x && MAP[qh2].x.indexOf(c)>-1;
        if(hit) b.style.display='none';
      });
      var on=qb.querySelector('.rw-qb__colour .is-on');
      if(on && on.style.display==='none' && !qb.__rwSw){ qb.__rwSw=1; setTimeout(function(){ qb.__rwSw=0; },1500); var vis=[].filter.call(qb.querySelectorAll('.rw-qb__colour .rw-qb__sw, .rw-qb__colour button'),function(b){ return b.style.display!=='none'; })[0]; if(vis) vis.click(); }
    }
  }
  window.rwHideColours=hideColours;
  fetch(url).then(function(r){ return r.json(); }).then(function(m){
    MAP=m; initCards(); hideColours();
    var pend=false; new MutationObserver(function(){ if(pend) return; pend=true; setTimeout(function(){ pend=false; initCards(); hideColours(); },250); }).observe(document.body,{childList:true,subtree:true});
  }).catch(function(){});
})();
